.noContent {
  padding: 8px 23px;
  color: var(--bc-color-text);
}
.select {
  width: 100%;
}

.dropdown {
  padding: 4px;
}

.dropdownContent {
  padding: 4px;
}

.tag {
  cursor: pointer;
}
